import { auth, User } from "firebase/app";

import { SessionTypes } from "./constants";

import {
  AuthChangedFailure,
  AuthChangedSuccess,
  UserUpdateProfileSuccess,
} from "./actionTypes";

export function userUpdateProfileSuccess(user: User): UserUpdateProfileSuccess {
  return ({
    type: SessionTypes.AUTH_USER_UPDATE_PROFILE_SUCCESS,
    payload: user,
  });
}

export function authChangeFailure(error: auth.Error): AuthChangedFailure {
  return ({
    type: SessionTypes.AUTH_CHANGED_FAILURE,
    payload: error,
  });
}

export function authChangeSuccess(user: User | null): AuthChangedSuccess {
  return ({
    type: SessionTypes.AUTH_CHANGED_SUCCESS,
    payload: user,
  });
}
